// src/pages/Calendar.jsx
import React, { useState } from "react";

export default function Calendar() {
  const [date, setDate] = useState("");

  return (
    <div className="p-6 max-w-3xl">
      <h1 className="text-2xl font-semibold mb-4">Calendar</h1>

      <div className="bg-white p-6 rounded-xl shadow border">
        <p className="text-gray-500 mb-2">Quick schedule</p>
        <input type="date" value={date} onChange={(e)=>setDate(e.target.value)} className="border p-2 rounded w-full" />
        <div className="mt-4 text-gray-600">Selected date: {date || "none"}</div>
      </div>

      <div className="mt-6">
        <div className="bg-white p-4 rounded-xl shadow border">
          <h2 className="font-semibold mb-2">Upcoming</h2>
          <ul className="text-sm text-gray-600">
            <li>Interview — Frontend — Nov 21, 2025</li>
            <li>Team Offsite — Dec 5, 2025</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
